import loadingPlugin from './loading'

let instance
const plugin = {
  install(vue) {
    const Constructor = vue.extend(loadingPlugin)
    if (!instance) {
      instance = new Constructor()
      instance.$mount()
    }
    document.querySelector('body').appendChild(instance.$el)
    vue.$loading = instance
    vue.mixin({
      created: function() {
        this.$loading = vue.$loading
      }
    })
  }
}
export default plugin
export const install = plugin.install



// WEBPACK FOOTER //
// ./src/components/loading/main.js